import React from 'react';
import classnames from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import UserAvatar from '../../../User/Avatar';
import UserIcon from '../../../Icons/User';
import s from './UserMenu.scss';
var UserMenuAvatar = function (_a) {
    var currentUser = _a.currentUser, isUserMenuOpened = _a.isUserMenuOpened, onToggleUserMenu = _a.onToggleUserMenu;
    return (React.createElement(React.Fragment, null, currentUser ? (React.createElement("div", { onClick: onToggleUserMenu, className: classnames(s['avatar-wrapper'], isUserMenuOpened && s['with-menu-open']) },
        React.createElement(UserAvatar, { user: currentUser, size: 30, className: s['avatar'], withLink: false, withTooltip: false }))) : (React.createElement("div", { onClick: onToggleUserMenu, className: classnames(s['avatar-wrapper'], isUserMenuOpened && s['with-menu-open']) },
        React.createElement(UserIcon, { className: classnames(s['anon-user-icon'], isUserMenuOpened && s['is-dark']), size: IconSize.MEDIUM, withPadding: true })))));
};
UserMenuAvatar.displayName = 'UserMenuAvatar';
export default UserMenuAvatar;
//# sourceMappingURL=UserMenuAvatar.js.map